<template>
  <div>
    <v-col cols="12" class="text-center">
      <h3 class="mb-4">¿Está seguro de realizar esta acción?</h3>
      <TextButton :disabled="loading" @click="confirmTercerArma">
        <template v-if="loading">
          <v-progress-circular indeterminate size="20" width="2" color="primary" class="mr-2" />
          Procesando...
        </template>
        <template v-else> Sí, Confirmar </template>
      </TextButton>
    </v-col>
  </div>
</template>

<script>
import TextButton from '@src/components/base/TextButton.vue'

export default {
  name: 'ConfirmacionTercerArmaDialogComponent',
  components: { TextButton },
  props: {
    item: Object,
    onConfirm: Function,
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async confirmTercerArma() {
      this.loading = true
      try {
        await this.onConfirm()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
